import { useCallback, useState } from "react"

export function useRadioGroup(initValue: string) {

	const [value, setValue] = useState(initValue)

	const onChange = useCallback((value: string) => {
		setValue(value)
		console.log("onChange")
	}, [])

	const rg = { value, onChange }

	return [rg, setValue] as [typeof rg, typeof setValue]
}